import React from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import Component from '../../components/Component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tab, Tabs, Typography } from '@mui/material';
import PulseCardList from './PulseCardList';
import PulseCardEditor from './PulseCardEditor';
import PulseMatches from './PulseMatches';
import PulseCompetitions from './PulseCompetitions';
import PulseKnowledgeUpload from './PulseKnowledgeUpload';
import PulseHotTakes from './PulseHotTakes';
import PulseAnalytics from './PulseAnalytics';
import PulseDeck from './PulseDeck';
import PulseActors from './PulseActors';
import PulseActorOrder from './PulseActorOrder';

function pulseTab(path) {
  if (path.startsWith('/admin/pulse/actors')) return 'actors';
  if (path.startsWith('/admin/pulse/matches')) return 'matches';
  if (path.startsWith('/admin/pulse/competitions')) return 'competitions';
  if (path.startsWith('/admin/pulse/deck')) return 'deck';
  if (path.startsWith('/admin/pulse/knowledge')) return 'knowledge';
  if (path.startsWith('/admin/pulse/hot-takes')) return 'hot-takes';
  if (path.startsWith('/admin/pulse/analytics')) return 'analytics';
  return 'cards';
}

function Pulse() {
  const location = useLocation();
  const tabValue = pulseTab(location.pathname);

  return (
    <Component>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm-10 d-flex align-items-center">
                <IconButton
                  style={{ background: '#FFFFFF', marginRight: 8 }}
                  component={Link}
                  to="/"
                >
                  <ArrowBackIcon />
                </IconButton>
                <div>
                  <h3 style={{ margin: 0 }}>Pulse Admin</h3>
                  <Typography variant="body2" color="text.secondary">
                    Enable competitions &amp; matches, manage cards, debug per-user deck order.
                    Cards are never deleted.
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <Tabs value={tabValue} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tab label="Cards" value="cards" component={Link} to="/admin/pulse" />
            <Tab label="App deck" value="deck" component={Link} to="/admin/pulse/deck" />
            <Tab label="Users" value="actors" component={Link} to="/admin/pulse/actors" />
            <Tab label="Matches" value="matches" component={Link} to="/admin/pulse/matches" />
            <Tab
              label="Competitions"
              value="competitions"
              component={Link}
              to="/admin/pulse/competitions"
            />
            <Tab label="Knowledge" value="knowledge" component={Link} to="/admin/pulse/knowledge" />
            <Tab label="Hot takes" value="hot-takes" component={Link} to="/admin/pulse/hot-takes" />
            <Tab label="Analytics" value="analytics" component={Link} to="/admin/pulse/analytics" />
          </Tabs>

          <Routes>
            <Route index element={<PulseCardList />} />
            <Route path="deck" element={<PulseDeck />} />
            <Route path="actors/order" element={<PulseActorOrder />} />
            <Route path="actors" element={<PulseActors />} />
            <Route path="matches" element={<PulseMatches />} />
            <Route path="competitions" element={<PulseCompetitions />} />
            <Route path="knowledge" element={<PulseKnowledgeUpload />} />
            <Route path="hot-takes" element={<PulseHotTakes />} />
            <Route path="analytics" element={<PulseAnalytics />} />
            <Route path="cards/:id" element={<PulseCardEditor />} />
          </Routes>
        </div>
      </div>
    </Component>
  );
}

export default Pulse;
